import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Book, MessageCircle, Phone, Mail } from 'lucide-react';
export function SupportPage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5735">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5736">
        <Link to="/" className="flex items-center gap-2" data-id="element-5737">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5738"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-5739">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-5740">
        <h1 className="text-4xl font-bold mb-4" data-id="element-5741">Support Center</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-5742">
          Get help with your Citiplots account and transactions
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-5743">
          <Link to="/faq" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5744">
            <Book className="w-8 h-8 mb-4" data-id="element-5745" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5746">FAQ</h3>
            <p className="text-sm text-gray-600" data-id="element-5747">
              Browse frequently asked questions
            </p>
          </Link>

          <Link to="/contact" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5748">
            <MessageCircle className="w-8 h-8 mb-4" data-id="element-5749" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5750">Contact Us</h3>
            <p className="text-sm text-gray-600" data-id="element-5751">Send us a message</p>
          </Link>

          <a href="tel:+911234567890" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5752">
            <Phone className="w-8 h-8 mb-4" data-id="element-5753" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5754">Call Support</h3>
            <p className="text-sm text-gray-600" data-id="element-5755">+91 123 456 7890</p>
          </a>

          <a href="mailto:support@citiplots.com" className="bg-white border border-gray-300 p-8 hover:bg-gray-50" data-id="element-5756">
            <Mail className="w-8 h-8 mb-4" data-id="element-5757" />
            <h3 className="font-bold text-lg mb-2" data-id="element-5758">Email Support</h3>
            <p className="text-sm text-gray-600" data-id="element-5759">support@citiplots.com</p>
          </a>
        </div>

        <div className="bg-white border border-gray-300 p-8" data-id="element-5760">
          <h2 className="font-bold text-xl mb-4" data-id="element-5761">Popular Help Topics</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5762">
            {['How to create a listing', 'Making an offer', 'Document verification', 'Payment methods', 'Account security', 'Transaction disputes'].map((topic, i) => <Link key={i} to="/faq" className="p-3 border border-gray-200 hover:bg-gray-50 text-sm" data-id="element-5763">
                {topic}
              </Link>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-5764" />
    </div>;
}